import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=306f99ec&scoped=true&"
import script from "./productCategory.js?vue&type=script&lang=js&"
export * from "./productCategory.js?vue&type=script&lang=js&"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=306f99ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f99ec",
  null
  
)

export default component.exports